import {
  ProductAvailabilityCodeLiteral,
  ProductAvailabilityNameLiteral,
  SharedDataSchema,
} from "reedy-data/models";

export const ProductAvailabilityCodes = Object.values(
  ProductAvailabilityCodeLiteral,
);

export const ProductAvailability = SharedDataSchema.properties
  .ProductAvailability.examples[0] as Record<
  ProductAvailabilityNameLiteral,
  ProductAvailabilityCodeLiteral
>;

export type ProductAvailabilityCode = (typeof ProductAvailabilityCodes)[number];
